import {useTranslation} from "react-i18next";
import Form from "react-bootstrap/Form";
import {SwalAlertClass} from "core/swalClass";
import {useRef} from "react";
import {publishEvent} from "core/eventsConnector";

const TabSelectFile = (props) => {
    const [t] = useTranslation("forms")
    const selectFile = useRef(new FormData());
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const changeFile = (e) => {
        const file = e.target.files[0];
        let name = file.name.split(/\./);
        let ext = name[name.length - 1];
        if (ext !== "xlsx") {
            Alert.error(
                t("errors.file-not-excel")
            )
            e.target.value = "";
            return false;
        }
        selectFile.current = new FormData();
        selectFile.current.append("excel-inventory", file);
    }
    const handleSendFile = (e) => {
        if (!selectFile.current.has("excel-inventory")) {
            Alert.warning(t("errors.file-must-selected"));
            return false;
        }
        publishEvent("notifyinventorychangesendfile", selectFile.current);
    }

    return (
        <div className="row">
            <div className="col-md-10 m-auto pt-5">
                <h2 className="mb-4">{t("inventory.title-tab-select")} &lt;&lt;{props.user.panel.name}&gt;&gt;</h2>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>{t("labels.select-inventory-file")}</Form.Label>
                    <Form.Control type="file" onChange={changeFile} lang="en"/>
                </Form.Group>
                <div className="row">
                    <div className="col-12 text-end">
                        <button className="btn btn-primary" onClick={handleSendFile}>{t("labels.send")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TabSelectFile



